export default __webpack_public_path__ + "static/media/twitter.b41bca87.svg";